import { USER_ROLE } from 'src/app/app-constants';
import { Model, MapTo } from 'src/app/decorators/mapto';

export class RoleModel extends Model {
    @MapTo()
    id: number;
    @MapTo()
    name: string;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }
}

export class PinLoginModel extends Model {
    @MapTo()
    role: RoleModel;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }

    get isAdmin(): boolean {
        return USER_ROLE.admin.id === this.role.id;
    }

    get isManager(): boolean {
        return USER_ROLE.manager.id === this.role.id;
    }

    get isOperator(): boolean {
        return USER_ROLE.operator.id === this.role.id;
    }
}
